/* eslint-disable react-hooks/exhaustive-deps */
import { useToast } from '../../hooks/toast'
import axios from 'axios'
import Header from '../../components/Header'
import MediaMatch from '../../components/MediaMatch'
import Footer from '../../components/Footer'
import * as S from '../../styles/page-profile'
import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'
import Filter from '../../components/Filter'
import IconFilter from '../../assets/img/icon-filter.svg'
import {
  FilterMobileButton,
  FilterMobileWrapper
} from '../../components/Filter/styles'
import { useState, useEffect, useContext } from 'react'
import FilterMobile from '../../components/FilterMobile'
import EmptyBox from '../../components/EmptyBox'
import { FilterDesktopContainer } from '../../styles/vendasPromovidas'
import Loader from '../../components/Loader'
import FichaPedido from '../../components/FichaPedido'
import Paginator from '../../components/Paginator'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'
import { getOrdersList } from '../../hooks/pedidos/usePedidos'
import { useQuery } from 'react-query'
import { UserContext } from '../../contexts/UserContext'
import { useHistory, useLocation } from 'react-router-dom'
import { capitalizePhrase } from '../../utils/utils'

function MeusPedidos() {
  const { filterParams, setFilterParams } = useContext(UserContext)
  const { addToast }: any = useToast()
  const location = useLocation()
  const history = useHistory()

  const [showMenu, setShowMenu] = useState(false)

  const { data, isLoading } = useQuery(
    [
      'pedidos',
      filterParams.IdStatus,
      filterParams.IdPedido,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getOrdersList(
        filterParams.IdStatus,
        filterParams.IdPedido,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: 'Verifique os campos e tente novamente'
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )
  const openMobileMenu = () => {
    setShowMenu((prev) => !prev)
  }

  const fetch = async (
    tipoOperacao: string,
    n: string,
    di: string,
    df: string,
    pg: number
  ) => {
    try {
      setFilterParams((prevParams) => ({
        ...prevParams,
        IdStatus: tipoOperacao,
        IdPedido: n,
        DataInicial: di,
        DataFinal: df,
        Page: pg
      }))

      history.replace('/meus-pedidos', null)
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Não foi possível realizar busca',
        description: 'Verifique os campos e tente novamente'
      })

      return err
    }
  }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  })

  useEffect(() => {
    getLocalStorageLog(location.pathname)
  }, [])

  const [filterOptions, setFilterOptions] = useState([])

  useEffect(() => {
    async function fetchFilterOptions() {
      // Acesso a API com sucesso
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_PEDIDOS}api/status`,
        )
        const filterData = response.data
        // Setar os dados relevantes para o select
        const transformedFilterOptions = filterData.map((item) => ({
          value: item.Id,
          label: //capitalizePhrase
          (item.MensagemCustomizada)
        }))
        // Ordenar por ordem alfabética com base na propriedade 'label'
        //transformedFilterOptions.sort((a, b) => a.label.localeCompare(b.label))
        // Adicionar 'Todos'
        transformedFilterOptions.unshift({ value: '', label: 'Todos' })
        // Setar a variável filterOptions com novos os valores da API
        setFilterOptions(transformedFilterOptions)
      } catch (error) {
        // Erro ao acessar a API
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: 'Tente novamente mais tarde'
        })
      }
    }

    fetchFilterOptions()
  }, [])

  return (
    <S.Main>
      {isLoading && <Loader />}

      <FilterMobile
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        pedido
        click={fetch}
        opcoes={filterOptions}
        gimplus={undefined}
        small={undefined}
        promotor={undefined}
      />
      <Header />
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Meus Pedidos</BreadcrumbItem>
                </Breadcrumb>

                <MediaMatch greaterThan="1171px">
                  <FilterDesktopContainer>
                    <ProfileTitle>Meus Pedidos</ProfileTitle>
                    <Filter
                      click={fetch}
                      opcoes={filterOptions}
                      pedido
                      promotor={undefined}
                      small={undefined}
                      gimplus={undefined}
                      setShowMenu={undefined}
                      calendarModal={undefined}
                    />
                  </FilterDesktopContainer>
                </MediaMatch>

                <MediaMatch lessThan="large">
                  <FilterMobileWrapper>
                    <ProfileTitle>Meus Pedidos</ProfileTitle>
                    <FilterMobileButton
                      align={true}
                      onClick={(e) => {
                        e.preventDefault()
                        openMobileMenu()
                      }}
                    >
                      <img src={IconFilter} alt="" />
                    </FilterMobileButton>
                  </FilterMobileWrapper>
                </MediaMatch>

                {data?.TotalCount === 0 && (
                  <EmptyBox>
                    <p>
                      <strong>Você ainda não tem pedidos :(</strong>
                    </p>
                    <br />
                    <p>
                      Navegue pelas categorias do site ou <br />
                      faça uma busca pelo seu produto.
                    </p>
                  </EmptyBox>
                )}

                <S.Fichas>
                  <FichaPedido pedidos={data?.Data} />
                </S.Fichas>

                <Paginator setFilterParams={setFilterParams} data={data} />
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>

      <Footer />
    </S.Main>
  )
}

export default MeusPedidos
